import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterFeature } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent implements OnInit {
  /**
   *
   */
  urlRedirection: String | null = null;

  constructor(
    private location: Location,
    private router: Router,
    private route: ActivatedRoute
  ) {
    
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.urlRedirection = params['url']
    });
  }

  goBack(){
    if(this.urlRedirection != null ){
      this.router.navigate([this.urlRedirection]);
    }else{
      this.location.back();
    }
  }
}
